/**
 * Main scripts bundle
 * Vite entry point
 */

// js-cookie
import Cookies from 'js-cookie';
window.Cookies = Cookies;

// Widgets
import '../js/widgets/cookieNote.js';
import '../js/widgets/productHoverImage.js';

// Main - import everything including the exported function
import * as Main from '../js/main.js';

// Expose replaceHistoryFromPreviousStep globally for other bundles
if (typeof window !== 'undefined' && Main.replaceHistoryFromPreviousStep) {
    window.replaceHistoryFromPreviousStep = Main.replaceHistoryFromPreviousStep;
}

// Autosuggest module (styles come in via build/scss/widget/header/_bssearch.scss)
import * as BSAutosuggest from '../../../autosuggest-module/resources/build/js/bsautosuggest.js';
if (typeof window !== 'undefined') {
    Object.keys(BSAutosuggest).forEach(key => {
        window[key] = BSAutosuggest[key];
    });
}
